import { useLocation, useNavigate } from "react-router-dom";

import type { MODAL_ROUTES } from "@/app/router/constants";
import type { Flatten, Path } from "@/shared/models/legacy-types";

type ModalRoute = Flatten<Path<typeof MODAL_ROUTES>>;

type ValidModalUrl<T extends string> = T extends `${infer _}/${infer _}`
  ? never
  : ModalRoute | `${ModalRoute}/${T}` | `${ModalRoute}/${T}/${T}`;

/**
 * @deprecated We're no longer going to use modals by route.
 */
export const useNavigateModal = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { previousLocation } = (location.state ?? {}) as {
    previousLocation?: Location;
  };

  // we make normal routing work as well as param routing, but make multiple params invalid
  return <T extends string>(
    url: ValidModalUrl<T>,
    state?: Record<string, unknown>,
  ) => {
    navigate(url, {
      state: { ...state, previousLocation: previousLocation ?? location },
    });
  };
};
